<app-form-modal
  [title]="title"
  [(visible)]="visible"
  formId="insuranceForm"
  (cancelForm)="onCancelInsuranceForm()"
  [disabled]="!submitHandler && (createInsuranceState$ | async)?.isLoading"
  [submitLabel]="
    !submitHandler && (createInsuranceState$ | async)?.isLoading ? 'Updating Insurance...' : 'Update Insurance'
  "
>
  <app-message
    *ngIf="!submitHandler && createInsuranceError"
    severity="error"
    [noMargin]="false"
    data-cy="crete-insurance-error-message"
  >
    {{ createInsuranceError }}
  </app-message>
  <div class="-mx-7">
    <form [formGroup]="insuranceForm" (ngSubmit)="onSubmitInsuranceForm()" id="insuranceForm" data-cy="insurance-form">
      <div class="px-7">
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            *ngIf="includeInsuranceType"
            class="col-12 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('insuranceType')!)"
            name="inruanceType"
            label="Insurance Type"
            type="dropdown"
            [options]="insuranceTypeOptions"
            placeholder="Insurance Type"
          ></app-form-field>
        </div>
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('insurancePlan')!)"
            name="insurancePlan"
            label="Insurance Plan"
            type="input"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('insuranceNumber')!)"
            name="insuranceNumber"
            label="Insurance Number"
            type="input"
          ></app-form-field>
        </div>
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('groupNumber')!)"
            name="groupNumber"
            label="Group Number"
            type="input"
            inputType="text"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('insurancePhone')!)"
            name="insurancePhone"
            label="Insurance Phone Number"
            type="input"
            inputMask="(999) 999-9999"
            placeholder="(999) 999-9999"
            inputMode="numeric"
          ></app-form-field>
        </div>
      </div>
      <p-divider></p-divider>
      <div class="px-7">
        <h3>Policy holder information</h3>
        <app-form-field
          [control]="asFormControl(insuranceForm.get('relationshipToInsured')!)"
          name="relationshipToInsured"
          label="Relationship to Patient"
          type="dropdown"
          [options]="(relationshipToInsuredOptions$ | async) || []"
          placeholder="Select relationship to patient"
        ></app-form-field>
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('firstName')!)"
            name="firstName"
            label="First Name"
            type="input"
            inputType="text"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('lastName')!)"
            name="lastName"
            label="Last Name"
            type="input"
            inputType="text"
          ></app-form-field>
        </div>
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('dob')!)"
            name="dob"
            label="Date of Birth"
            placeholder="mm/dd/yyyy"
            type="calendar"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('gender')!)"
            name="gender"
            label="Gender"
            type="dropdown"
            [options]="genderOptions"
            placeholder="Select a gender"
          ></app-form-field>
        </div>
        <app-form-field
          [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('phoneNumber')!)"
          name="phoneNumber"
          label="Phone Number"
          type="input"
          inputMask="(999) 999-9999"
          placeholder="(999) 999-9999"
          inputMode="numeric"
        ></app-form-field>
        <app-form-field
          [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('line1')!)"
          name="line1"
          label="Address"
          type="input"
          inputType="text"
        ></app-form-field>
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('city')!)"
            name="city"
            label="City"
            type="input"
            inputType="text"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('state')!)"
            name="state"
            label="State"
            type="dropdown"
            [options]="(usStateOptions$ | async) || []"
            placeholder="Select State"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
            [control]="asFormControl(insuranceForm.get('policyHolderInformation')!.get('zipCode')!)"
            name="zipCode"
            label="Zip Code"
            type="input"
          ></app-form-field>
        </div>
      </div>
    </form>
  </div>
</app-form-modal>
